import { render, staticRenderFns } from "./Hospitalar.vue?vue&type=template&id=57152282&"
import script from "./Hospitalar.vue?vue&type=script&lang=js&"
export * from "./Hospitalar.vue?vue&type=script&lang=js&"
import style0 from "./Hospitalar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports